module.exports = __webpack_public_path__ + "static/media/document-upload-2.74e14b85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/document-upload-2.jpg
// module id = 443
// module chunks = 0